import axios from "axios";

import { SERVER_URL } from "../../config";
import {
  appendTimestamp,
  convertYearToAgeByClient,
  getSelectedClient,
  MONTH_LIST,
  MONTH_NUM_MAP,
} from "../../common/shared";

import { getClientDisplayNameById } from "../../common/shared";

import { getSelectedClientAppliesToType } from "../../common/shared";

const getIncomeTypeLabel = (incomeType) => {
  if (incomeType === "PAYROLL") return "Payroll";
  if (incomeType === "SOCIAL_SECURITY") return "Social Security";
  if (incomeType === "PENSION") return "Pension";
  if (incomeType === "BUSINESS") return "Business";
  return "Other";
};

export const mapBEIncomeToFEIncome = (income, index) => {
  return {
    clientId: income.clientId,
    incomeId: income.id,
    id: income.id,
    editIndex: index,
    incomeType: { key: income.type, name: getIncomeTypeLabel(income.type) },
    incomeName: income.name,
    name: income.name,
    mirroredName: income.name,
    frequency: { key: income.amount.frequency, name: "Yearly" },
    isEdited: false,
    isCopy: false,
    appliesTo: {
      id: income.appliesTo.appliesToId ? income.appliesTo.appliesToId : 0,
      name: getClientDisplayNameById(income.appliesTo.appliesToId),
    },
    appliesToName: getClientDisplayNameById(income.appliesTo.appliesToId),
    amount: income.amount.amount,
    totalYearsInflatedAmount: income.amount.totalYearsInflatedAmount,
    interval: income.interval,
    startYear: income.date.startYear,
    startMonth: income.date.startMonth,
    endYear: income.date.endYear,
    endMonth: income.date.endMonth,
    startAge: convertYearToAgeByClient(
      income.date.startYear,
      getSelectedClient({
        id: income.appliesTo.appliesToId ? income.appliesTo.appliesToId : 0,
      }),
      MONTH_LIST[income.date.startMonth - 1]
    ),
    endAge: convertYearToAgeByClient(
      income.date.endYear,
      getSelectedClient({
        id: income.appliesTo.appliesToId ? income.appliesTo.appliesToId : 0,
      }),
      MONTH_LIST[income.date.endMonth - 1]
    ),
    start: new Date(
      income.date.startYear,
      income.date.startMonth - 1,
      income.date.startMonth - 1 === 11 ? 31 : 1
    ),
    end: new Date(
      income.date.endYear,
      income.date.endMonth - 1,
      income.date.endMonth - 1 === 11 ? 31 : 1
    ),
    endDateValid: true,
    startDateValid: true,
    inflationRate: income.amount.inflationRate / 100,
    scopeType: income.scopeType,
    notes: income.note,
    usedInPlans: [],
    futureValue: income.amount.futureValue,
    isIncludedInTaxGlidePath: income.isIncludedInTaxGlidePath,
    incomeTaxClassifications: null,
  };
};

export const mapFEIncomeToBEIncome = (income, clientId) => {
  return {
    id: income.incomeId,
    name: income.name,
    type: income.incomeType.key,
    isCopied: income.isCopy,
    clientId: clientId,
    appliesTo: {
      appliesToId: income.appliesTo.id,
      appliesToType: getSelectedClientAppliesToType(income.appliesTo),
    },
    amount: {
      frequency: "MONTHLY",
      amount: income.amount,
      inflationRate:
        income.inflationRate !== null ? income.inflationRate * 100 : null,
      futureValue: income.futureValue,
    },
    date: {
      startDateType: "REGULAR_DATE",
      endDateType: "REGULAR_DATE",
      relativeStartDateNum: 0,
      relativeEndDateNum: 0,
      startYear: income.startYear,
      endYear: income.endYear,
      startMonth: income.startMonth,
      endMonth: income.endMonth,
    },
    isEdited: income.isEdited,
    interval: income.interval,
    note: income.notes,
    scopeType: income.scopeType,
    isIncludedInTaxGlidePath: income.isIncludedInTaxGlidePath,
    incomeTaxClassification: null,
  };
};

export const getAdvisorIncomeList = (advisorId, clientId) => {
  console.log("Advisor Income API - getAdvisorIncomeList");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/incomes`
    );
    axios.get(targetUrl).then((response) => {
      const payload = response.data.payload;
      resolve(payload.map(mapBEIncomeToFEIncome));
    });
  });
};

/*export const saveAdvisorIncome = (advisorId, clientId, income) => {

    console.log("Advisor Income API - saveAdvisorIncome");

    return new Promise((resolve, reject) => {

        const targetUrl = appendTimestamp(`${SERVER_URL}/advisor/${advisorId}/client/${clientId}/income`);
        const payload = mapFEIncomeToBEIncome(income, clientId);

        if (payload.id === null) {
            axios.post(targetUrl, payload)
                .then((response) => {
                    const payload = response.data.payload;
                    resolve(mapBEIncomeToFEIncome(payload));
                });
        } else {
            axios.put(targetUrl, payload)
                .then((response) => {
                    const payload = response.data.payload;
                    resolve(mapBEIncomeToFEIncome(payload));
                });
        }
    });
};

export const deleteAdvisorIncome = (advisorId, clientId, incomeId) => {
    console.log("Advisor Income API - deleteAdvisorIncome");

    return new Promise((resolve, reject) => {
        const targetUrl = appendTimestamp(`${SERVER_URL}/advisor/${advisorId}/client/${clientId}/income/${incomeId}`);

        axios.delete(targetUrl)
            .then(() => {
                resolve({});
            });
    });
};*/

export const batchUpdateAdvisorIncome = (advisorId, clientId, incomeList) => {
  console.log("Advisor Income API  - batchUpdateAdvisorIncome");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/incomes`
    );
    const payload = incomeList.map((item) => {
      return mapFEIncomeToBEIncome(item, clientId);
    });

    axios.post(targetUrl, payload).then((response) => {
      const result = response.data.payload.map((item) => {
        return mapBEIncomeToFEIncome(item);
      });
      resolve(result);
    });
  });
};

export const batchDeleteAdvisorIncome = (advisorId, clientId, deleteList) => {
  console.log("Advisor Income API - batchDeleteIncome");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/income/batch-delete`
    );

    axios.post(targetUrl, deleteList).then(() => resolve({}));
  });
};
